import { AppBar, styled } from '@mui/material';

const PREFIX = 'InformationRequestModalAppBar';

export const classes = {
  appBar: `${PREFIX}-appBar`,
  title: `${PREFIX}-title`,
  tableHead: `${PREFIX}-tableHead`,
  tablesWithoutBorders: `${PREFIX}-tablesWithoutBorders`,
  chipSpace: `${PREFIX}-chipSpace`,
  closeButton: `${PREFIX}-closeButton`,
  dialogContent: `${PREFIX}-dialogContent`,
};

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.appBar}`]: {
    position: 'relative',
  },

  [`& .${classes.title}`]: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  [`& .${classes.tableHead}`]: {
    marginLeft: theme.spacing(2),
    fontWeight: 'bold',
  },

  [`& .${classes.tablesWithoutBorders}`]: {
    border: 'none',
  },

  [`& .${classes.chipSpace}`]: {
    marginRight: '8px',
    marginBottom: '8px',
    display: 'inline-block',
  },

  [`& .${classes.closeButton}`]: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

  [`& .${classes.dialogContent}`]: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(2.5),
  },
}));